import { History } from 'history';
import queryString from 'query-string';

import { getRecordType } from 'app/Signal/Records/Records';
import {
  GetEntityTimelineGroupsQuery as GetEntityTimelineGroups,
  GetRecordGroupDetailsQuery as GetRecordGroupDetails,
  RecordSearchResultsOperationQuery as RecordSearchResultsOperation,
  RuleExpressionResultsOperationQuery as RuleExpressionResultsOperation,
  SumoRawMessageLookupJobResultOperationQuery as SumoRawMessageLookupJobResultOperation,
  SumoSearchJobState,
} from 'core/graphql';

import {
  RecordSearchDateRangeRelativeValue,
  recordSearchDateRangeRelativeValues,
  RecordSearchDateRangeValue,
} from '../RecordSearchDateRangeSelect';

type ResultsDataType =
  | RecordSearchResultsOperation
  | RuleExpressionResultsOperation
  | GetRecordGroupDetails;

type StateDataType =
  | ResultsDataType
  | SumoRawMessageLookupJobResultOperation
  | GetEntityTimelineGroups;

export const parseRecord = (r: string) => {
  try {
    const parsed = JSON.parse(r);
    parsed._type = getRecordType(parsed);
    return parsed;
  } catch (e) {
    console.error('Failed to parse record:', e);
    return {};
  }
};

export const checkDoneGathering = (data?: StateDataType) =>
  data?.sumoRecordSearchJobStatus?.state ===
  SumoSearchJobState.DoneGatheringResults;

export const checkHasResults = (data?: ResultsDataType) =>
  !!(data?.sumoRecordSearchJobResults?.length || checkDoneGathering(data));

export const getRecords = (data?: ResultsDataType) =>
  (data?.sumoRecordSearchJobResults || []).map(parseRecord);

export const deserializeDateRangeQueryParams = (
  history: History<any>,
  defaultDateRange: RecordSearchDateRangeValue
): RecordSearchDateRangeValue => {
  const {
    date: relativeDateRange,
    startDate,
    endDate,
  } = queryString.parse(history.location.search);

  if (
    recordSearchDateRangeRelativeValues.includes(
      relativeDateRange as RecordSearchDateRangeRelativeValue
    )
  ) {
    return relativeDateRange as RecordSearchDateRangeRelativeValue;
  } else if (startDate && endDate) {
    return [new Date(startDate as string), new Date(endDate as string)];
  } else {
    return defaultDateRange;
  }
};

export const onSelectDateRange = (
  history: History<any>,
  dateRange: RecordSearchDateRangeValue
) => {
  const qs = queryString.parse(history.location.search);

  let startDate: string | undefined;
  let endDate: string | undefined;
  let relativeDateRange: string | undefined;

  if (typeof dateRange === 'string') {
    relativeDateRange = dateRange;
  } else {
    startDate = dateRange[0].toISOString();
    endDate = dateRange[1].toISOString();
  }

  history.push({
    ...history.location,
    search: queryString.stringify({
      ...qs,
      startDate,
      endDate,
      date: relativeDateRange,
      offset: 0,
    }),
  });
};
